import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import styled from "styled-components";

const LinkContainer = styled((props) => <Link {...props} />)`
  display: flex;
  align-items: center;
  margin: 10px 0;
`;
const FabButtonBig = styled.button`
  background-color: #fff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.35);
  margin: 0 8px 5px 5px;
  width: 50px;
  height: 50px;
  border-radius: 50px;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    background-color: rgb(0 0 0 / 5%);
    text-decoration: none;
  }
`;
const FabButtonSmall = styled((props) => <Link {...props} />)`
  background-color: #fff;
  color: #1b2636;
  border: 1px solid #bdbdbd;
  border-radius: 56px;
  margin: 0 15px;
  width: 56px;
  height: 56px;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    background-color: #f15e4e;
    border: 1px solid #f15e4e;
  }
  &:hover svg {
    color: #fff;
  }
`;

const LinkLabel = styled.h3`
  font-size: 1rem;
  padding-left: 20px;
  margin: 0;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

export default function RoundIconButton(props) {
  const btnSize =
    props.small === true ? (
      <FabButtonSmall to={props.link} id={props.id}>
        {props.icon}
      </FabButtonSmall>
    ) : (
      <LinkContainer to={props.link} id={props.id}>
        <FabButtonBig>{props.icon}</FabButtonBig>
        <LinkLabel>{props.linkLabel}</LinkLabel>
      </LinkContainer>
    );
  return <span>{btnSize}</span>;
}

RoundIconButton.propTypes = {
  icon: PropTypes.string,
  link: PropTypes.string,
  linkLabel: PropTypes.string,
  small: PropTypes.bool,
  id: PropTypes.string,
};

RoundIconButton.defaultProps = {
  icon: "",
  link: "",
  linkLabel: "",
  small: false,
  id: "",
};
